import api from './api'

export const newsBasePath = '/api/v1/news'
export const newsCmsBasePath = '/api/v1/cms-news'

// used by homepage and news landing at the moment
export async function fetchNews({ page, limit }) {
  const resp = await api.get(`${newsCmsBasePath}/public/${page}/${limit}`)
  return resp.data
}

export async function createNews(news) {
  const resp = await api.post(`${newsCmsBasePath}`, news)
  return resp.data
}

export async function editNews(news, id) {
  const resp = await api.patch(`${newsCmsBasePath}/${id}`, news)
  return resp.data
}

export async function getNewsItem(id) {
  const resp = await api.get(`${newsCmsBasePath}/${id}`)
  return resp.data
}

export async function getNewsItemBySeq(seq) {
  const resp = await api.get(`${newsCmsBasePath}/get-by-seq/${seq}`)
  return resp.data
}

export async function getNewsList() {
  const resp = await api.get(`${newsCmsBasePath}`)
  return resp.data
}

export async function deleteNews(id) {
  const resp = await api.delete(`${newsCmsBasePath}/${id}`)
  return resp.data
}
